import { RealEstateConstructionPageProvider } from "../../context/industryPageProviders";
import IndustryPageLayout from "./IndustryPageLayout";

export default function RealEstateConstruction() {
  return (
    <RealEstateConstructionPageProvider>
      <IndustryPageLayout />
    </RealEstateConstructionPageProvider>
  );
}
